import styled from "styled-components";
import { CrumbBarStyle } from "./crumbBar";
import { palette, size } from "styled-theme";

export const CrumbStepContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${CrumbBarStyle} {
    flex: 1;
  }
`;

export const CrumbContainer = styled.div`
  display: flex;
  flex-direction: column;

  .ring {
    background-image: linear-gradient(
      135deg,
      #feed07 0%,
      #fe6a50 5%,
      #eae54b 15%,
      #2fe3fe 50%,
      #9b30f2 100%
    );
    border-radius: 50%;
    animation-duration: 2s;
    animation-name: rotate;
    animation-iteration-count: infinite;
    width: 62px;
    height: 62px;
    position: absolute;
    z-index: 1;

    &.is-not-active {
      display: none;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .crumb-title {
    color: #8c8c8c;
    text-align: center;
    line-height: 1.2;
    padding-top: 7px;
    font-size: 14px;

    &.crumb-title-mobile {
      @media only screen and (min-width: ${size("M")}) {
        display: none;
      }
    }

    &.crumb-title-desktop {
      display: none;
      font-size: 15px;

      @media only screen and (min-width: ${size("M")}) {
        display: block;
      }
    }
  }

  &.is-active {
    .crumb-title {
      font-weight: bold;
      color: ${palette("color", 15)};
      @media only screen and (min-width: ${size("M")}) {
        color: ${palette("color", 15)};
      }
    }
  }

  &.is-complete {
    .crumb-title {
      color: #8c8c8c;
      @media only screen and (min-width: ${size("M")}) {
        color: #8c8c8c;
      }
    }
  }
`;
